import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Grid } from 'semantic-ui-react';
import { startGetAllBlogs } from '../../actions/blog';
import ListBlog from './ListBlog';
import { LocaleContext } from '../../locale-context';

const BlogsContent = ({ blogs, language }) => (
    <React.Fragment>
        {blogs.map(
            blog =>
                blog.deleted === false ? (
                    blog.language === language ? (
                        <ListBlog
                            key={blog.id}
                            title={blog.title}
                            blogId={blog.id}
                            author={blog.author}
                            date={blog.date}
                            summary={blog.summary}
                            content={blog.content}
                            votes={blog.votes}
                            selectedFile={blog.selectedFile}
                        />
                    ) : (
                        ''
                    )
                ) : (
                    ''
                )
        )}
    </React.Fragment>
);

class Blog extends Component {
    componentDidMount() {
        this.props.startGetAllBlogs();
    }

    render() {
        const translations = {
            en: {
                header1: 'Blog',
                quote:
                    '“We must become the change we want to see.” — Mahatma Gandhi',
                header2:
                    'Those are some personal thoughts regarding different subjects I want to approach..'
            },
            ro: {
                header1: 'Blog',
                quote:
                    '“Trebuie sa devenim schimbarea pe care o dorim sa o vedem.” — Mahatma Gandhi',
                header2:
                    'Aceastea reprezinta cateva topicuri care ma pasioneaza..'
            }
        };
        const { blogs, language } = this.props;
        const labels = translations[language];
        return (
            <React.Fragment>
                <section className="cover cover-middle">
                    <div className="text-box">
                        <h1 className="heading-primary">
                            <span className="heading-primary-main">
                                {labels.header1}
                            </span>
                            <span className="heading-primary-sub">
                                {labels.quote}
                            </span>
                        </h1>
                    </div>
                </section>

                <Container fluid className="service-list">
                    <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                        <p className="paragraph">{labels.header2}</p>
                    </div>
                    <Grid stackable columns="equal" columns={2}>
                        <BlogsContent blogs={blogs} language={language} />
                    </Grid>
                </Container>
            </React.Fragment>
        );
    }
}

const LocaleConsumer = props => (
    <LocaleContext.Consumer>
        {value => <Blog language={value} {...props} />}
    </LocaleContext.Consumer>
);

function mapStateToProps(state) {
    return {
        blogs: state.blogReducer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        startGetAllBlogs: () => dispatch(startGetAllBlogs())
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LocaleConsumer);



// WEBPACK FOOTER //
// ./src/components/Blog/Blog.js